import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { fetchAudits, fetchAuditsCSV } from '../actions/audits'

import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import AuditEntryList from '../components/AuditEntryList'

import AuditFilterForm from '../forms/AuditFilterForm'

import '../styles/AuditView.css'

class AuditView extends React.Component {
  constructor(props) {
    super(props)

    this.handleCSV = this.handleCSV.bind(this)
  }

  componentDidMount() {
    const today = new Date().toISOString().substring(0, 10)
    this.props.fetchAudits('', '', today, today)
  }

  handleCSV() {
    const { fetchAuditsCSV, form } = this.props

    fetchAuditsCSV(
      form.AuditFilterForm.values.Machine,
      form.AuditFilterForm.values.Type,
      form.AuditFilterForm.values.StartDate,
      form.AuditFilterForm.values.EndDate
    )
  }

  renderResume() {
    const { audits, error, loading } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!audits || loading) {
      return <LoadingProgress />
    }

    const counts = { INFO: 0, CHANGE: 0, MONEY: 0, LOGIN: 0, INFO_LOCKERS: 0, ERROR: 0, ERROR_LOCKERS: 0 }

    this.props.audits.forEach(audit => {
      const cat = audit.Categoria || ''
      if (counts[cat] !== undefined) counts[cat]++
    })

    const stats = [
      { label: 'Info', value: counts.INFO, icon: 'fa-info-circle', color: '#28a745' },
      { label: 'Cambios', value: counts.CHANGE, icon: 'fa-edit', color: '#ffc107' },
      { label: 'Dinero', value: counts.MONEY, icon: 'fa-coins', color: '#f48c42' },
      { label: 'Login', value: counts.LOGIN, icon: 'fa-key', color: '#0077ff' },
      { label: 'Info Lockers', value: counts.INFO_LOCKERS, icon: 'fa-lock-open', color: '#43a047' },
      { label: 'Errores', value: counts.ERROR + counts.ERROR_LOCKERS, icon: 'fa-exclamation-triangle', color: '#e53935' },
    ]

    return (
      <div className="audit-summary-grid">
        {stats.map(s => (
          <div key={s.label} className="audit-summary-stat">
            <div className="audit-stat-icon" style={{ color: s.color }}>
              <i className={`fas ${s.icon}`}></i>
            </div>
            <div className="audit-stat-value">{s.value}</div>
            <div className="audit-stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    )
  }

  renderAudits() {
    const { audits, error, loading } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!audits || loading) {
      return <LoadingProgress />
    }

    return (<AuditEntryList audits={audits} />)
  }

  render() {
    return (
      <div className="audit-view">
        <div className="audit-header">
          <div className="audit-header-content">
            <div className="audit-header-text">
              <h1>
                <i className="fas fa-clipboard-list mr-3"></i>
                <span className="text-vw-dark mr-1">Audit</span>
                <span className="text-vw-light">Log</span>
              </h1>
            </div>
            <div className="audit-header-actions">
              <button className="audit-header-btn success" onClick={this.handleCSV}>
                <i className="fas fa-file-excel"></i>
                <span>Descargar CSV</span>
              </button>
            </div>
          </div>
        </div>

        <div className="audit-filter-card">
          <div className="audit-filter-header">
            <h3><i className="fas fa-filter"></i> Filtros</h3>
          </div>
          <div className="audit-filter-body">
            <AuditFilterForm />
          </div>
        </div>

        <div className="audit-section-card">
          <div className="audit-section-header">
            <i className="fas fa-chart-bar mr-2"></i>Resumen del período
          </div>
          <div className="audit-section-body">
            {this.renderResume()}
          </div>
        </div>

        <div className="audit-section-card">
          <div className="audit-section-header">
            <i className="fas fa-list mr-2"></i>Registros
          </div>
          <div className="audit-section-body p-0">
            {this.renderAudits()}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  audits: state.audits.audits,
  error: state.audits.error,
  loading: state.audits.loading,
  form: state.form,
})

const mapDispatchToProps = dispatch => ({
  fetchAudits: bindActionCreators(fetchAudits, dispatch),
  fetchAuditsCSV: bindActionCreators(fetchAuditsCSV, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(AuditView)


